import {createRouter as createTanStackRouter} from '@tanstack/react-router'
import {routerWithQueryClient} from '@tanstack/react-router-with-query'
import {QueryClient} from '@tanstack/react-query'
import NotFound from '~/components/NotFound'
import {routeTree} from './routeTree.gen'
import Error from '~/components/Error'

export function createRouter() {
    const queryClient = new QueryClient()

    return routerWithQueryClient(
        // @ts-ignore FIXME
        createTanStackRouter({
            routeTree,
            context: {queryClient},
            defaultPreload: 'intent',
            defaultErrorComponent: () => <Error />,
            defaultNotFoundComponent: () => <NotFound />,
            scrollRestoration: true,
        }),
        queryClient
    )
}

declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof createRouter>
    }
}
